module.exports = __webpack_public_path__ + "1d969e9ce87c461a002d78687f56c903.png";